import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [kind, setKind] = useState(localStorage.getItem("crm_kind") || "user");

  useEffect(() => {
    const token = localStorage.getItem("crm_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        setKind(r.data.kind || "user");
      })
      .catch(() => {
        localStorage.removeItem("crm_token");
        localStorage.removeItem("crm_user");
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    localStorage.setItem("crm_token", data.token);
    localStorage.setItem("crm_kind", "user");
    localStorage.setItem("crm_user", JSON.stringify(data.user));
    setUser({ ...data.user, kind: "user" });
    setKind("user");
    return data;
  };

  const clientLogin = async (token, client) => {
    localStorage.setItem("crm_token", token);
    localStorage.setItem("crm_kind", "client");
    localStorage.setItem("crm_user", JSON.stringify(client));
    setUser({ ...client, kind: "client" });
    setKind("client");
  };

  const logout = async () => {
    const wasClient = localStorage.getItem("crm_kind") === "client";
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("crm_token");
    localStorage.removeItem("crm_user");
    localStorage.removeItem("crm_kind");
    localStorage.removeItem("crm_active_biz");
    setUser(null);
    window.location.href = wasClient ? "/portal" : "/login";
  };

  const refreshMe = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("crm_user", JSON.stringify(data));
      return data;
    } catch { return null; }
  };

  const hasPerm = (perm) => {
    if (!user) return false;
    const perms = user.permissions || [];
    if (perms.includes("*")) return true;
    if (perms.includes(perm)) return true;
    const mod = perm.split(".")[0];
    return perms.includes(`${mod}.*`);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, kind, login, clientLogin, logout, hasPerm, refreshMe }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
